import { ClipboardList, CreditCard, Search, Send } from "lucide-react";

const STEPS = [
  { icon: ClipboardList, title: "Preencha o pedido", text: "Selecione o serviço e informe seus dados em menos de 2 minutos." },
  { icon: CreditCard, title: "Pague com segurança", text: "Escolha Pix, Cartão em até 12x ou Boleto. Ambiente 100% seguro." },
  { icon: Search, title: "Nossa equipe processa", text: "Especialistas analisam e executam sua solicitação com cuidado." },
  { icon: Send, title: "Receba no WhatsApp", text: "Seus documentos e comprovantes chegam no WhatsApp e e-mail." },
];

export default function HowItWorks() {
  return (
    <section id="como-funciona" className="py-20 lg:py-28 bg-[#0F294A] text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: "radial-gradient(circle at 1px 1px, white 1px, transparent 0)", backgroundSize: "26px 26px" }} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="max-w-2xl mb-14">
          <p className="text-xs font-semibold tracking-wider uppercase text-emerald-400 mb-3">Como Funciona</p>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">
            Simples, rápido e sem complicação
          </h2>
          <p className="mt-4 text-lg text-slate-300">Da solicitação ao documento na sua mão, em 4 passos.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-7">
          {STEPS.map((s, i) => (
            <div key={s.title} data-testid={`how-step-${i + 1}`} className="relative rounded-2xl bg-white/5 border border-white/10 p-6 backdrop-blur-sm hover:bg-white/10 transition-colors">
              <span className="font-heading text-5xl font-extrabold text-white/10 absolute top-4 right-5">{i + 1}</span>
              <span className="grid place-items-center h-12 w-12 rounded-xl bg-emerald-500/20 text-emerald-400 mb-4">
                <s.icon className="h-6 w-6" />
              </span>
              <h3 className="font-heading font-bold text-lg">{s.title}</h3>
              <p className="mt-2 text-sm text-slate-300 leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
